if (
  typeof Array !== undefined
  && Array.prototype
  && !Array.prototype.moveToIndexByIndex
) {
  Object.defineProperty(Array.prototype, 'moveToIndexByIndex', {
    value(index, newIndex) {
      if (newIndex > -1 && newIndex < this.length) this.splice(newIndex, 0, this.splice(index, 1)[0]);
      return this;
    }
  });
}